import routes from './routes'
import { LobbyEntryProps, LobbyEntryTypes } from './components/LobbyEntry/LobbyEntry'

// audio
// import LobbyMusic from './images/audio/lobby.mp3'

// icons & decorations
import InfoIcon from './images/lobbyEntry/infoIcon.png'
import PinIcon from './images/lobbyEntry/arrowIcon.png'

const dev = {
  // apiUrl: 'http://localhost:3000',
  apiUrl: 'https://2022.moaasm.com',
}

const prod = {
  apiUrl: 'https://2022.moaasm.com',
}

const API_KEYS = {
  amplitude: '6fd6d913e1b38ef4e81e561cc730deff',
}

const VOLUME_VALUE = 0.4

// Root page will show either EntrancePage or CountdownPage
// based on the following time setting
const EVENT_START_TIME = {
  year: 2022,
  month: 6,
  day: 9,
  hour: 0,
  minute: 0,
}

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  entrance: {
    landscape: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/entrance.jpg',
    portrait: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/entranceM.jpg',
  },
  lobby: {
    landscape: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/lobby.jpg',
    portrait: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/lobbyM.png',
  },
  auditorium1: {
    landscape: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/auditorium.jpg',
    portrait: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/auditoriumM.png',
  },

  exhibition1: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/exhibition.jpg',


  networking: {
    landscape: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/networking.jpg',
    portrait: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/networkingM.jpg',
  },
  gallerium: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/gallerium.jpg',

  // lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 20%;
    bottom: 28%;
    left: 15%;
    right: 34%;
  `,
}

const lobbyEntries: Array<LobbyEntryProps & { id: string }> = [
  {
    id: 'auditorium-1',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.programme,
    pinImage: PinIcon,
    css: `
      top: 68.8%;
      left: 19%;
      right: 74%;
      bottom: 23.5%;
    `,
  },
  {
    id: 'auditorium-2',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.programme,
    pinImage: PinIcon,
    css: `
      top: 68.8%;
      left: 76.8%;
      right: 16%;
      bottom: 23.5%;
    `,
  },
  {
    id: 'exhibition',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.exhibition1,
    pinImage: PinIcon,
    css: `
      top: 67%;
      left: 46%;
      right: 43.5%;
      bottom: 23.5%;
    `,
  },
  {
    id: 'networking',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.networking,
    pinImage: PinIcon,
    css: `
      top: 55.8%;
      left: 26.7%;
      right: 66.5%;
      bottom: 37%;
    `,
  },
  {
    id: 'gallerium',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.onDemand,
    pinImage: PinIcon,
    css: `
      top: 55.8%;
      left: 69%;
      right: 24%;
      bottom: 37%;
    `,
  },
  {
    id: 'helpdesk',
    type: LobbyEntryTypes.Helpdesk,
    pinImage: InfoIcon,
    css: `
      top: 89%;
      left: 20%;
      right: 85%;
      bottom: 20.5%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,
  EVENT_START_TIME,

  eventName: 'Malaysian Orthopaedic Association (ASM & AGM) 2022',

  ...config,
}
